import { Theme } from '@mui/material'

const useStyles = {
  animationContainer: (theme: Theme) => ({
    width: `calc(100% + ${theme.spacing(4)})`,
    marginLeft: theme.spacing(-2),
  }),
  sidewalkText: {
    fontSize: '24px',
    fontWeight: 300,
    lineHeight: '33px',
    letterSpacing: 0,
    marginTop: 4,
    strong: {
      fontStyle: 'italic',
    },
  },
  descriptionText: {
    marginTop: 2,
    marginBottom: 2,
  },
}

export default useStyles
